export const FILTER_VALUE_SEARCH_THRESHOLD = 20;

/** Vertical gap between the filter trigger and the top of the options list. */
export const FILTER_OPTIONS_LIST_GAP_PX = 2;

/** Keep the options list this far above the bottom of the window. */
export const FILTER_OPTIONS_LIST_MARGIN_PX = 40;

export const SPECIAL_FILTER_OPTIONS = ['[Empty]', '[Not Empty]'] as const;

/** Columns that use a free-text filter input (partial match) instead of a value dropdown. */
export const TEXT_FILTER_COLUMNS = ['TestId'] as const;

export function isSpecialFilterOption(option: string): boolean {
  return option === '[Empty]' || option === '[Not Empty]';
}

export function isTextFilterColumn(columnOrName: string | { name?: string } | null | undefined): boolean {
  const name = typeof columnOrName === 'string' ? columnOrName : columnOrName?.name;
  return Boolean(name && (TEXT_FILTER_COLUMNS as readonly string[]).includes(name));
}

export function getDataFilterOptions(options: string[] | null | undefined): string[] {
  if (!Array.isArray(options)) return [];
  return options.filter((option) => option && !isSpecialFilterOption(option));
}

export function shouldUseSearchableFilter(options: string[] | null | undefined): boolean {
  return getDataFilterOptions(options).length > FILTER_VALUE_SEARCH_THRESHOLD;
}

/**
 * Narrows dropdown choices while typing. Special Empty/Not Empty options stay visible;
 * data values match when they contain the search text (case-insensitive).
 */
export function filterOptionsBySearch(
  options: string[] | null | undefined,
  search: string
): string[] {
  if (!Array.isArray(options)) return [];
  const needle = String(search ?? '').trim().toLowerCase();
  if (!needle) return [...options];

  const specials = options.filter(isSpecialFilterOption);
  const matchingData = options.filter(
    (option) => !isSpecialFilterOption(option) && String(option).toLowerCase().includes(needle)
  );
  return [...specials, ...matchingData];
}

/**
 * Max height for the recents filter options list: fill remaining space below
 * the trigger down to `marginPx` from the container bottom (the viewport).
 * Content shorter than this still shrinks.
 */
export function availableFilterOptionsMaxHeight(
  listTop: number,
  containerBottom: number,
  marginPx = FILTER_OPTIONS_LIST_MARGIN_PX
): number {
  return Math.max(0, Math.floor(containerBottom - listTop - marginPx));
}
